import type {AxiosError} from "axios";

const FATAL_ERROR_CODES = new Set(["TOKEN_REVOKED", "TOKEN_EXPIRED", "TOKEN_INVALID"]);

export type SessionFatal401 = {
  fatal: true;
  errorCode: string;
  reason: string | undefined;
};

type ErrorBody = {
  error_code?: unknown;
  data?: {reason?: unknown; action?: unknown} | null;
};

export function parseSessionFatal401(error: AxiosError): SessionFatal401 | null {
  if (error.response?.status !== 401) {
    return null;
  }

  const body = (error.response.data ?? {}) as ErrorBody;
  const errorCode = typeof body.error_code === "string" ? body.error_code : "";
  const action =
    body.data && typeof body.data.action === "string" ? body.data.action : "";

  if (!FATAL_ERROR_CODES.has(errorCode) || action !== "relogin") {
    return null;
  }

  return {
    fatal: true,
    errorCode,
    reason:
      body.data && typeof body.data.reason === "string" ? body.data.reason : undefined,
  };
}

export function mapFatal401ToSessionEndReason(fatal: SessionFatal401): string {
  const {reason, errorCode} = fatal;

  if (reason) {
    return reason;
  }
  if (errorCode === "TOKEN_EXPIRED") {
    return "session_timeout";
  }
  if (errorCode === "TOKEN_INVALID") {
    return "token_invalid";
  }
  return "unknown";
}
